var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoRounded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_506_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.3923 74.0014C57.5511 74.0014 73.893 57.4356 73.893 37.0007C73.893 16.5658 57.5511 0 37.3923 0C17.2335 0 0.891602 16.5658 0.891602 37.0007C0.891602 57.4356 17.2335 74.0014 37.3923 74.0014Z",
    fill: "#1D69AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4403 50.3875H22.349C22.1447 50.3875 21.9424 50.3467 21.7537 50.2675C21.565 50.1883 21.3935 50.0721 21.2491 49.9257C21.1046 49.7793 20.99 49.6054 20.9119 49.4141C20.8337 49.2228 20.7935 49.0178 20.7935 48.8107V19.3391C20.7935 19.1321 20.8337 18.9271 20.9119 18.7359C20.9901 18.5447 21.1047 18.3709 21.2491 18.2246C21.3936 18.0783 21.5651 17.9623 21.7538 17.8832C21.9425 17.8041 22.1448 17.7635 22.349 17.7637H31.3784C31.7445 17.7634 32.099 17.8942 32.3793 18.1329C32.6596 18.3716 32.8478 18.703 32.9106 19.0687L37.9726 48.5403C38.0112 48.7668 38.0006 48.9991 37.9415 49.221C37.8823 49.4429 37.7761 49.6491 37.6301 49.825C37.4842 50.0009 37.3021 50.1424 37.0966 50.2396C36.8911 50.3368 36.6671 50.3873 36.4403 50.3875V50.3875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4318 56.2391H43.4024C43.0362 56.239 42.6817 56.108 42.4014 55.869C42.1211 55.63 41.933 55.2985 41.8702 54.9327L36.8082 25.4611C36.7693 25.2346 36.7797 25.0023 36.8388 24.7803C36.8979 24.5584 37.0041 24.3522 37.1502 24.1763C37.2962 24.0004 37.4784 23.8591 37.684 23.7621C37.8896 23.6652 38.1137 23.6151 38.3405 23.6152H52.4318C52.636 23.6151 52.8382 23.6557 53.0268 23.7348C53.2154 23.8139 53.3868 23.9299 53.5312 24.0763C53.6755 24.2226 53.79 24.3963 53.8681 24.5876C53.9461 24.7788 53.9862 24.9837 53.986 25.1907V54.6623C53.9862 54.8693 53.9461 55.0743 53.8681 55.2656C53.7901 55.4569 53.6756 55.6307 53.5313 55.7772C53.3869 55.9236 53.2155 56.0398 53.0269 56.119C52.8383 56.1983 52.636 56.2391 52.4318 56.2391V56.2391Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_506_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 74,
    fill: "white",
    transform: "translate(0.891602)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRounded);
export default __webpack_public_path__ + "static/media/logo-rounded.356b872dd0c10aac69260db745fc776f.svg";
export { ForwardRef as ReactComponent };